<script>
import DropDownMixin from "../mixins/DropDownMixin";

export default {
  async mounted() {},
  mixins: [DropDownMixin],
  data() {
    return {};
  },

  methods: {
    generateGPBookmark: function(tmpDatas) {
      let currentURL =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
      let bookmarkURL = currentURL + "/?";
      if (
        typeof this.countryList !== "undefined" &&
        this.countryList.length > 0
      ) {
        let tmpProperties = "";
        let datas = this.removeProperties(tmpDatas, ["copyToDoctors"]);
        let keys = Object.keys(datas);
        let country = this.countryList.find(
          (country) => country.value === datas["country"]
        );
        for (let key in keys) {
          let property = keys[key];
          let value = datas[property];
          if (value !== null && value !== "") {
            switch (property) {
              case "country":
                value = country.displayText;
                break;
              case "state":
                if (country === "AUS") {
                  value = country.states.find((state) => state.value === value)
                    .displayText;
                  break;
                }
              default:
              // code block
            }
            if (property !== keys[0] && tmpProperties !== "") {
              tmpProperties += "&";
            }
            tmpProperties += property + "=" + value;
          }
        }
        bookmarkURL += tmpProperties;
      }
      return bookmarkURL;
    },
    removeProperties: function(obj, array) {
      return Object.keys(obj)
        .filter((k) => !array.includes(k))
        .reduce((acc, key) => ((acc[key] = obj[key]), acc), {});
    },
  },
};
</script>
